import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { ColumnState, GridApi } from 'ag-grid-community';
import { ServerDashboardDashboard, ServerDashboardJob } from './dashboardType';

export const dashboardAtom = atom<ServerDashboardDashboard | null>(null);

export const selectedRowsAtom = atom<ServerDashboardJob[]>([]);

export const dashboardClientAPIAtom = atom<GridApi | null>(null);


// Persists AG Grid's per-column filter model (e.g. active filter values/UI
// state per column) so filter icons and filter panels reflect the restored
// state when the dashboard is reopened.
//
// `getOnInit: true` is required here: without it, this atom holds `null` on
// the very first render after a page reload (F5) and only hydrates from
// localStorage in a later effect. AG Grid's `onGridReady` fires from a child
// effect that runs before that hydration effect, so it would capture the
// stale `null` and skip restoring the filter model - leaving the filter
// icons visually un-indicated even though the applied filters/query are
// correct.
export const dashboardColumnFilterModelAtom = atomWithStorage<Record<
  string,
  unknown
> | null>('dashboard-column-filter-model', null, undefined, {
  getOnInit: true,
});

// Persists AG Grid's full column state (visibility, order, width, pinning)
// as chosen via the sidebar's "Columns" tool panel, so those choices survive
// closing/reopening the dashboard - mirroring `dashboardColumnFilterModelAtom`
// above. Same `getOnInit: true` requirement applies: without it, `onGridReady`
// would fire and skip restoration before this atom hydrates from localStorage.
export const dashboardColumnStateAtom = atomWithStorage<ColumnState[] | null>(
  'dashboard-column-state',
  null,
  undefined,
  { getOnInit: true }
);


